import * as React from "react";
import { Divider, Spin, Typography } from "antd";
import { IOrganisationIndexByDateReportPresenter } from "../../presenter/OrganisationIndexByDateReportPresenter";
import IndexHarmonizationReportParamBox from "../components/IndexHarmonizationReportParamBox";
import IndexHarmonizationReportPreview from "../components/IndexHarmonizationReportPreview";
import { FileExcelOutlined } from "@ant-design/icons";
import OrganisationIndexByDateParamBox from "../components/OrganisationIndexByDateParamBox";

export interface Props {}

export interface State extends IOrganisationIndexByDateReportPresenter {}

export default class OrganisationIndexByDateReportPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState(() => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      indexCategories,
      setOrganisationIds,
      setCategoryId,
      organisations,
      selectedCategoryId,
      organisationIds,
      user,
      fromDate,
      toDate,
      onChangeDateRange
    } = this.state;

    return (
      <Spin spinning={this.state.loaders.projectLoader}>
        <div style={{ display: "flex", flexDirection: "row", height: "100%" }}>
          <OrganisationIndexByDateParamBox
            translate={translate}
            indexCategories={indexCategories}
            setOrganisationIds={setOrganisationIds}
            organisationIds={organisationIds}
            organisations={organisations}
            setCategoryId={setCategoryId}
            selectedCategoryId={selectedCategoryId}
            user={user}
            fromDate={fromDate}
            toDate={toDate}
            onChangeDateRange={onChangeDateRange}
          />
          <Divider type={"vertical"} style={{ height: "100%" }} />
          {
            <div style={{ width: "75%", paddingLeft: 10 }}>
              <div>
                <Typography.Title style={{ fontSize: 20 }}>
                  {translate("reports.indexes_by_date_report")}
                </Typography.Title>
              </div>
            </div>
          }
        </div>
      </Spin>
    );
  }
}
